var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Configurator } from '@api/services/configurator';
import { formatPrice } from "../../utils";
// Id iPhone Pro : 5341
var DeviceOneTimePriceBox = /*@__PURE__*/ (function () {
    function DeviceOneTimePriceBox(container) {
        this.template = " <div class=\"price-box\">\n" +
            "                                        <div class=\"price-box__price\" id=\"tariff-price-box-id\">\n" +
            "                                            <span class=\"price-box__price-euro\">00</span>\n" +
            "                                            <span class=\"price-box__price-cent-period\">\n" +
            "                                                <span class=\"price-box__price-cent\">00 €</span>\n" +
            "                                                <span class=\"price-box__price-period\">einmalig</span>\n" +
            "                                           </span>\n" +
            "                                        </div>\n" +
            "                                    </div>";
        this.container = container;
        this.init();
    }
    DeviceOneTimePriceBox.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.container.innerHTML = this.template;
                Configurator.subscribe('offerChanged', this.onOfferChanged.bind(this));
                this.onOfferChanged();
                return [2 /*return*/];
            });
        });
    };
    DeviceOneTimePriceBox.prototype.onOfferChanged = function () {
        this.setPrice().then();
    };
    DeviceOneTimePriceBox.prototype.setPrice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var product, offer, price, priceStr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Configurator.getProduct()];
                    case 1:
                        product = _a.sent();
                        return [4 /*yield*/, Configurator.getOffer()];
                    case 2:
                        offer = _a.sent();
                        this.product = product;
                        price = offer.getOnetimePrice();
                        if (price <= 1) {
                            this.container.classList.add('red');
                        }
                        else {
                            this.container.classList.remove('red');
                        }
                        priceStr = formatPrice(price);
                        this.container.querySelector('.price-box__price-euro').textContent = priceStr["euro"];
                        this.container.querySelector('.price-box__price-cent').textContent = priceStr["cents"] + " " + priceStr["currency"];
                        return [2 /*return*/];
                }
            });
        });
    };
    return DeviceOneTimePriceBox;
}());
export default DeviceOneTimePriceBox;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/shared/DeviceOneTimePriceBox.ts
// module id = null
// module chunks = 